/**
 * Получить все роли.
 *
 * @returns {[string, string, string]}
 */
function getAllRoles () {
  return ['SUPER_ADMIN_ROLE', 'ADMIN_ROLE', 'USER_ROLE']
}

export { getAllRoles }
